import usePageTitle from "@/hooks/usePageTitle";
import { useParams, useNavigate } from "react-router-dom";
import EditJobPostForm from "@/components/Forms/JobPostForm/EditJobPostForm";
import { DOMAIN, PERMISSION, useRequireCapability } from "@/hooks/useCapabilities";

export default function JobPostEditPage() {
  useRequireCapability({ domain: DOMAIN.JOBS, permission: PERMISSION.manageJobPosts });
  usePageTitle("Jobs | Edit Job Post");
  const { jobPostId } = useParams();
  const navigate = useNavigate();

  if (!jobPostId) {
    return <div>Unable to find job post.</div>;
  }

  const handleSuccess = (id: string) => {
    navigate(`/jobs/job-post/${id}/details`);
  };

  return <EditJobPostForm jobPostId={jobPostId} onSuccess={handleSuccess} />;
}
